<script setup lang="ts">
  import { computed } from 'vue'
  import type { ReminderIcon } from './BaseReminder.types'
  import { TEST_ID } from './BaseReminder.constants'
  import SslIcon from '@/shared/components/icons/SslIcon.vue'
  import ShieldIcon from '@/shared/components/icons/ShieldIcon.vue'

  interface Props {
    icon?: ReminderIcon
  }

  const props = withDefaults(defineProps<Props>(), {
    icon: 'none',
  })

  const iconComponent = computed(() => {
    switch (props.icon) {
      case 'lock':
        return SslIcon
      case 'shield':
        return ShieldIcon
      default:
        return 'div'
    }
  })
</script>

<template>
  <div class="reminder" :data-testid="TEST_ID">
    <div>
      <component :is="iconComponent" />
    </div>
    <p class="reminder__text">
      <slot />
    </p>
  </div>
</template>

<style lang="scss" scoped>
  @import './BaseReminder';
</style>
